export default {
      id: "ic_tv2-usage",
      viewBox: "0 0 16 11",
      url: "/" + "images/icons.3.109.2.svg#ic_tv2-usage",
      toString: function () {
        return this.url;
      }
    }